import _ from 'lodash'
import globals from 'scoreboard/components/globals'
import LabelForm from 'scoreboard/components/label-form'

var SaveReportForm = LabelForm.extend({

	initialize: function(options) {
		LabelForm.prototype.initialize.apply(this, arguments)
		this.formView.options.test = () => {
			return this.model.validate(this.model.attributes, {formView: true})
		}
	},

	render: function() {
		LabelForm.prototype.render.apply(this, arguments)
		this.model.isNew() && this.$('[name=label]').select()
		return this
	},

	submit: function(e) {
		if (this.model.isNew() && _.isNil(this.model.get('organizationId'))) {
			this.model.set('organizationId', globals.orgId)
		}

		return LabelForm.prototype.submit.apply(this, arguments)
	}

})

export default SaveReportForm

SaveReportForm.__filename__ = 'reports/save-report-form.js'
